export function onDocumentReady(callback) {
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', () => {
            callback()
        })
    } else {
        callback()
    }
}
